import React, { useState } from 'react'
import { Popover, PopoverBody, Badge } from 'reactstrap'
import RepAvatar from '../../../Material/RepAvatar'
import AssignmentEditor from './AssignmentEditor'

// Adapt our AssignedRepNode ({ id (int), gid, firstName, lastName, username })
// into RepAvatar's expected shape (RepAvatar uses `firstName`, `lastName`,
// `username`, and `id` for the online-status pip).
function toRepAvatarShape(rep) {
    return {
        id: rep.gid,
        firstName: rep.firstName,
        lastName: rep.lastName,
        username: rep.username,
        name: [rep.firstName, rep.lastName].filter(Boolean).join(' ') || rep.username,
    }
}

export default function Assignees({ caseId, assignedTo = [] }) {
    const [overflowOpen, setOverflowOpen] = useState(false)
    const [editorOpen, setEditorOpen] = useState(false)

    const reps = assignedTo
    const isUnassigned = reps.length === 0
    const editTargetId = `cd-edit-assign-${caseId}`
    const emptyTargetId = `cd-empty-assign-${caseId}`
    const overflowTargetId = `cd-overflow-assign-${caseId}`
    const shown = reps.slice(0, 2)
    const hidden = reps.slice(2)

    return (
        <span
            className="cd-assignees-row"
            onClick={(e) => e.stopPropagation()}
        >
            {isUnassigned && (
                <span
                    id={emptyTargetId}
                    className="cd-assignees-empty"
                    title="Unassigned — click to assign"
                    onClick={(e) => {
                        e.stopPropagation()
                        setEditorOpen(true)
                    }}
                >
                    <i className="fa fa-user-o" aria-label="Unassigned" />
                </span>
            )}
            {shown.map((rep) => (
                <RepAvatar key={rep.id || rep.gid} rep={toRepAvatarShape(rep)} keepClose />
            ))}
            {hidden.length > 0 && (
                <Badge
                    id={overflowTargetId}
                    color="secondary"
                    pill
                    className="cd-assignees-overflow"
                    onClick={(e) => {
                        e.stopPropagation()
                        setOverflowOpen((x) => !x)
                    }}
                >
                    +{hidden.length}
                </Badge>
            )}
            {!isUnassigned && (
                <i
                    id={editTargetId}
                    title="Edit collectors"
                    className="fa fa-pencil-square-o cd-assignees-edit"
                    onClick={(e) => {
                        e.stopPropagation()
                        setEditorOpen(true)
                    }}
                />
            )}

            {overflowOpen && (
                <Popover
                    trigger="legacy"
                    placement="bottom"
                    isOpen={overflowOpen}
                    target={overflowTargetId}
                    toggle={() => setOverflowOpen(false)}
                >
                    <PopoverBody>
                        {reps.map((rep) => (
                            <div key={rep.id || rep.gid} style={{ marginBottom: 4 }}>
                                <RepAvatar rep={toRepAvatarShape(rep)} keepOpen />
                            </div>
                        ))}
                    </PopoverBody>
                </Popover>
            )}

            {editorOpen && (
                <AssignmentEditor
                    caseId={Number(caseId)}
                    target={isUnassigned ? emptyTargetId : editTargetId}
                    isOpen={editorOpen}
                    initialReps={reps}
                    onClose={() => setEditorOpen(false)}
                />
            )}
        </span>
    )
}
